// import fetch from 'cross-fetch';
import {URL} from './api';
import axios from 'axios';
import queryString from 'query-string'
import Cookies from 'universal-cookie';

import {helpBarAction, helpBarReset} from './helpbarAction'
import {validateEmail} from './functions'

export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const LOGIN_FETCH = 'LOGIN_FETCH';
export const LOGIN_FORGOT_SUCCESS = 'LOGIN_FORGOT_SUCCESS';
export const LOGIN_FORGOT_FETCH = 'LOGIN_FORGOT_FETCH'
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_DETAIL = 'LOGIN_DETAIL'
export const SIGNUP_FETCH = 'SIGNUP_FETCH';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const PACE_RESET = 'PACE_RESET';

const cookies = new Cookies();

function successLogin(response){      
    const {first_login} = response.results
    const isInfluencer = response.results.role === 'influencer'
    const role = {
        "administrator":"administrator",
        "influencer":"influencer",
        "advertiser":"advertiser",
        "customer":"administrator",
        "customer-happiness":"administrator",
        "writer":"administrator"
    }[response.results.role]        
    const auth = {
        token : response.results.token,
        isLogin : true,
        role
    }     
    // localStorage.setItem('auth' , JSON.stringify(auth))    

    cookies.set('auth', JSON.stringify(auth), { path: '/' });
    
    window.location.href = `/${role}${isInfluencer && first_login ? '/profile': '/overview'}${first_login ? '?tour=1': ''}`
    return({
        type: LOGIN_DETAIL,
        data: auth
    })
}

function successRegister(res, history, query){
    
    history.push(`/signup/success?${query}`)
}

export function CheckAuth(){    
    let auth = cookies.get('auth');  


    auth && auth.isLogin ? window.location.href = `./${auth.role}/overview` : false;
}


function loginFetch(){
    return {
        type: LOGIN_FETCH
    }
}


function loginError(){
    return {
        type: LOGIN_ERROR
    }
}


function signUpFetch(){
    return {
        type: SIGNUP_FETCH
    }
}

function signUpError(){
    return {
        type: SIGNUP_ERROR
    }
}

export function LoginAction(email, password){           
    return dispatch => {
        dispatch(loginFetch())
        axios.post(URL+'/login',{                      
            email,
            password 
        }).then(response => {
            dispatch(successLogin(response.data) )           
        }).catch(error => {
            dispatch(loginError())
            if(email === '' || password === ''){
                dispatch(helpBarAction({messages: 'Silakan lengkapi isian form yang tersedia.'}))
            }else if(error.response.status === 401){
                dispatch(helpBarAction({messages: error.response.data.message}))
            }
            
        })
    }
};    

export function signupActivation(code, history){    
    
    axios.post(URL+'/activation', {
        activation_code: code
    }, {
        headers: {
            'Accept' : 'application/json',
        }
    }).then((res) => {
        history.push('/signup/complete')
    }).catch((err) => {
        history.push('/signup/success')
    })    
}

export function paceReset(){
    return {
        type: PACE_RESET
    }
}

export function SignupAction(
    email,
    name,    
    password,    
    account_type,    
    last_name,
    history
){    
    return dispatch => {    
        
        dispatch(signUpFetch())    
        axios.post(URL + '/register/'+account_type, {
                email,
                name: name + ' ' + last_name,
                password,                
            },{
            headers: {                
                'Accept' : 'application/json',
            }
        }).then( (response) => {
            successRegister(
                response, 
                history, 
                queryString.stringify({
                    email,
                })
            )
            dispatch(helpBarReset())
            dispatch(paceReset())
        }
        ).catch(error => {
            dispatch(signUpError())
            if(email === '' || name === '' || password === ''){
                dispatch(helpBarAction({messages: 'Silakan lengkapi isian form yang tersedia.'}))                
            }else if(!validateEmail(email)){
                dispatch(helpBarAction({messages: ' Silakan masukkan format email dengan benar.'}))                
            }else if(account_type === ''){
                dispatch(helpBarAction({messages: ' Silakan pilih tipe pengguna yang akan Anda inginkan.'}))                
            }else if(error.response.status === 422){
                dispatch(helpBarAction({messages: error.response.data.errors.email}))                
            }else{
                dispatch(helpBarAction({messages: 'something error, refresh and try again.'}))                
            }
            // if(error.response.status === 500 ) window.location.href = '/login'            
        })
    }
}

function loginForgotSuccess(){
    return{
        type: LOGIN_FORGOT_SUCCESS
    }
}


function loginForgotFetch(){
    return{
        type: LOGIN_FORGOT_FETCH
    }
}


export function loginForgot(email, history){
    return dispatch => {
        dispatch(loginForgotFetch())
        axios.post(URL + '/password/email', {
            email,     
        }, {
            headers: {
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            
            dispatch(helpBarReset())
            dispatch(loginForgotSuccess())
            if(res.data.success){
                history.push('/login/forgot/success')            
            }else{
                dispatch(helpBarAction({messages: res.data.message}))
            }            
        }).catch((error) => {            
            dispatch(loginForgotSuccess())
            if(email === '' ){
                dispatch(helpBarAction({messages: 'Silakan lengkapi isian form yang tersedia.'}))
            }else if(error.response.status === 422){
                dispatch(helpBarAction({messages: error.response.data.errors.email}))                
            }                
            // history.push('/signup/success')
        })   
    }
}

export function resetPassword(data, token, history){
    return dispatch => {
        dispatch(loginForgotFetch())
        axios.post(URL + '/password/reset', {
            email: data.email,
            password: data.password,
            password_confirmation: data.password_confirmation,
            token
        }
        ).then((res) => {
            dispatch(loginForgotSuccess())
            history.push('/login/complete')            
        }).catch((err) => {
            dispatch(loginForgotSuccess())
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js